import React from 'react';
import './sub-header-component.css';

/**
 * Composant de sous-en-tête qui affiche un titre et un sous-titre optionnel sur fond gris.
 * 
 * @param {Object} props - Propriétés du composant
 * @param {string} props.title - Le titre principal du sous-en-tête
 * @param {string} [props.subtitle] - Le sous-titre optionnel (affiché en plus petit)
 * @param {string} [props.className] - Classes CSS additionnelles
 */
const SubHeaderComponent = ({ title, subtitle, className = '' }) => {
  return (
    <div className={`app-subheader ${className}`}>
      <h2 className="app-subheader-title">
        {title}
        {subtitle && <span className="app-subheader-subtitle">{subtitle}</span>}
      </h2>
    </div>
  );
};

export default SubHeaderComponent;